var map = {
	"./clinique-ca-loyalty.json": [
		"./src/config/clinique-ca-loyalty.json",
		"src_config_clinique-ca-loyalty_json"
	],
	"./clinique-com-loyalty.json": [
		"./src/config/clinique-com-loyalty.json",
		"src_config_clinique-com-loyalty_json"
	],
	"./maccosmetics-ca-loyalty.json": [
		"./src/config/maccosmetics-ca-loyalty.json",
		"src_config_maccosmetics-ca-loyalty_json"
	],
	"./maccosmetics-com-loyalty.json": [
		"./src/config/maccosmetics-com-loyalty.json",
		"src_config_maccosmetics-com-loyalty_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/config lazy recursive ^\\.\\/.*\\-loyalty\\.json$";
module.exports = webpackAsyncContext;